import { useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';

export const COLOR_MODE_OPTIONS = [
  { value: 'auto', label: 'Automatisch' },
  { value: 'light', label: 'Hell' },
  { value: 'dark', label: 'Dunkel' },
];

/**
 * Nachtmodus des Portals.
 *
 * `preference` ist die lokale Einstellung (nur dieses Gerät): 'auto' | 'light' | 'dark'.
 * `mode` ist das tatsächlich aktive Farbschema. Bei 'auto' folgt es dem
 * Betriebssystem (`prefers-color-scheme`) – also denselben Zeiten, zu denen
 * auch Googles Adressfelder und macOS/Windows umschalten.
 */
const useColorMode = () => {
  const preference = useSelector((state) => state.settings?.local?.colorMode) || 'auto';
  const systemDark = useMediaQuery('(prefers-color-scheme: dark)', { noSsr: true });
  const mode = preference === 'auto' ? (systemDark ? 'dark' : 'light') : preference;
  return { preference, mode };
};

export default useColorMode;
